<template>
	<div class="scrollable only-y">
	<div class="page-header card-base card-shadow--medium" v-loading="loadingDetail" element-loading-background="rgba(0, 0, 0, 0.8)">
		<h2 class="no-m white-text"><i class="mdi mdi-bank widget-icon accent-text fs-30"></i> Finance Credit</h2>
	</div>
	<el-card>
		<el-tabs type="border-card" v-model="activeTab" v-loading="loadingPage">
			<el-tab-pane label="Approvement" name="approvement">
				<el-table
					element-loading-text="Loading..."
					element-loading-spinner="el-icon-loading"
					:data="listApprovementArr"
					height="500"
				>
					<el-table-column prop="information_action" label="Information and Action" width="400">
                        <template slot-scope="scope">
							<table border="0" cellspacing="0" cellpadding="0">
								<tr style="background-color: transparent;">
									<td style="border: none;" colspan="2">{{`${scope.row.customer.customer_name} (${scope.row.phone_number})`}}</td>
								</tr>
								<tr style="background-color: transparent;">
									<td style="border: none;">Credit Type</td>
									<td style="border: none;text-transform: capitalize">{{ `: ${scope.row.credit_type}` }}</td>
								</tr>
								<tr style="background-color: transparent;">
									<td style="border: none;">Credit Requester</td>
									<td v-if="scope.row.requester" style="border: none;">{{ `: ${scope.row.requester.username}` }}</td>
									<td v-else style="border: none;">{{ `: -` }}</td>
								</tr>
								<tr style="background-color: transparent;">
									<td style="border: none;">Date Request</td>
									<td style="border: none;">{{ `: ${formatedDate(scope.row.created_at)}` }}</td>
								</tr>
								<tr style="background-color: transparent;">
									<td style="border: none;">Status</td>
									<td style="border: none;text-transform:capitalize;">{{ `: ${scope.row.status}` }}</td>
								</tr>
								<tr style="background-color: transparent;">
									<td style="border: none;">Action</td>
									<td class="d-flex" style="border: none;">
										<el-button @click="submitApprovement('reject', scope.row)" size="mini" type="primary">Reject</el-button>
										<el-button v-if="scope.row.credit_type.toLowerCase()==='addition'" @click="btnApprovement('addition', scope.row.id, scope.row)" size="mini" type="primary">Approve</el-button>
										<el-button v-else-if="scope.row.credit_type.toLowerCase()==='reduction'" @click="btnApprovement('reduction', scope.row.id, scope.row)" size="mini" type="primary">Approve</el-button>
									</td>
								</tr>
							</table>
						</template>
                    </el-table-column>
                    <el-table-column prop="market_area" label="Market Area" width="180">
                        <template slot-scope="props">
							<div
								style="height: 13em;"
								v-for="item in props.row.master_request_topup_markets"
								:key="item.id"
							>
								<p v-if="item.market_area">{{ item.market_area.name }}</p>
								<p v-else>-</p>
							</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="credit_type" label="Credit Type" width="200">
                        <template slot-scope="props">
							<div
								style="height: 13em;"
								v-for="(item, idx) in props.row.master_request_topup_markets"
								:key="item.id"
							>
								<table>
									<tr style="background-color: transparent;">
										<td style="border: none;">Authentication</td>
									</tr>
									<tr style="background-color: transparent;">
										<td style="border: none;">Marketing</td>
									</tr>
									<tr style="background-color: transparent;">
										<td style="border: none;">Utility</td>
									</tr>
									<tr style="background-color: transparent;">
										<td style="border: none;">Service</td>
									</tr>
								</table>
							</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="credit_balance" label="Credit Balance" width="150">
                        <template slot-scope="props">
							<div
								style="height: 13em;"
								v-for="(item, idx) in props.row.master_request_topup_markets"
								:key="item.id"
							>
								<table>
									<tr style="background-color: transparent;">
										<td v-if="item.authentication_before_topup" style="border: none;">{{ `${formatNumber(item.authentication_before_topup)}` }}</td>
										<td v-else style="border: none;">-</td>
									</tr>
									<tr style="background-color: transparent;">
										<td v-if="item.authentication_before_topup" style="border: none;">{{ `${formatNumber(item.marketing_before_topup)}` }}</td>
										<td v-else style="border: none;">-</td>
									</tr>
									<tr style="background-color: transparent;">
										<td v-if="item.utility_before_topup" style="border: none;">{{ `${formatNumber(item.utility_before_topup)}` }}</td>
										<td v-else style="border: none;">-</td>
									</tr>
									<tr style="background-color: transparent;">
										<td v-if="item.service_before_topup" style="border: none;">{{ `${formatNumber(item.service_before_topup)}` }}</td>
										<td v-else style="border: none;">-</td>
									</tr>
								</table>
							</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="credit_request" label="Credit Request" width="150">
                        <template slot-scope="props">
							<div
								style="height: 13em;"
								v-for="(item, idx) in props.row.master_request_topup_markets"
								:key="item.id"
							>
								<table>
									<tr style="background-color: transparent;">
										<td v-if="item.authentication" style="border: none;">{{ `${formatNumber(item.authentication)}` }}</td>
										<td v-else style="border: none;">-</td>
									</tr>
									<tr style="background-color: transparent;">
										<td v-if="item.marketing" style="border: none;">{{ `${formatNumber(item.marketing)}` }}</td>
										<td v-else style="border: none;">-</td>
									</tr>
									<tr style="background-color: transparent;">
										<td v-if="item.utility" style="border: none;">{{ `${formatNumber(item.utility)}` }}</td>
										<td v-else style="border: none;">-</td>
									</tr>
									<tr style="background-color: transparent;">
										<td v-if="item.service" style="border: none;">{{ `${formatNumber(item.service)}` }}</td>
										<td v-else style="border: none;">-</td>
									</tr>
								</table>
							</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="mutation" label="Mutation" width="150">
                        <template slot-scope="props">
							<div
								style="height: 13em;"
								v-for="(item, idx) in props.row.master_request_topup_markets"
								:key="item.id"
							>
								<table>
									<tr style="background-color: transparent;">
										<td v-if="item.authentication_after_topup" style="border: none;">{{ `${formatNumber(item.authentication_after_topup)}` }}</td>
										<td v-else style="border: none;">-</td>
									</tr>
									<tr style="background-color: transparent;">
										<td v-if="item.marketing_after_topup" style="border: none;">{{ `${formatNumber(item.marketing_after_topup)}` }}</td>
										<td v-else style="border: none;">-</td>
									</tr>
									<tr style="background-color: transparent;">
										<td v-if="item.utility_after_topup" style="border: none;">{{ `${formatNumber(item.utility_after_topup)}` }}</td>
										<td v-else style="border: none;">-</td>
									</tr>
									<tr style="background-color: transparent;">
										<td v-if="item.service_after_topup" style="border: none;">{{ `${formatNumber(item.service_after_topup)}` }}</td>
										<td v-else style="border: none;">-</td>
									</tr>
								</table>
							</div>
                        </template>
                    </el-table-column>
					<el-table-column prop="remark" label="Remark" width="300">
                        <template slot-scope="scope">
							<div style="height: 13em;">
								<p v-if="scope.row.remark">{{ scope.row.remark }}</p>
								<p v-else>-</p>
							</div>
                        </template>
                    </el-table-column>
                </el-table>
			</el-tab-pane>
			<el-tab-pane label="Client General Ledger" name="clientGeneralLedger">
				<el-table class="v2-table.styled" style="width: 100%" element-loading-text="Loading..." element-loading-spinner="el-icon-loading" :data="listClientLedgerArr" height="500">
                    <el-table-column prop="information" label="Information" width="400">
                        <template slot-scope="scope">
							<table v-if="scope.row.credit_type==='addition' || scope.row.credit_type==='Addition'" border="0" cellspacing="0" cellpadding="0">
								<tr style="background-color: transparent;">
									<td style="border: none;" colspan="2">{{`${scope.row.customer.customer_name} (${scope.row.phone_number})`}}</td>
								</tr>
								<tr style="background-color: transparent;">
									<td style="border: none;width: 130px;">Credit Type</td>
									<td style="border: none;text-transform: capitalize;">{{ `: ${scope.row.credit_type}` }}</td>
								</tr>
								<tr style="background-color: transparent;">
									<td style="border: none;width: 130px;">Credit Requester</td>
									<td v-if="scope.row.requester" style="border: none;">{{ `: ${scope.row.requester.username}` }}</td>
									<td v-else style="border: none;">{{ `: -` }}</td>
								</tr>
								<tr style="background-color: transparent;">
									<td style="border: none;width: 130px;">Date Request</td>
									<td style="border: none;">{{ `: ${formatedDate(scope.row.created_at)}` }}</td>
								</tr>
								<tr style="background-color: transparent;">
									<td style="border: none;width: 130px;">Credit Approver</td>
									<td v-if="scope.row.approver" style="border: none;">{{ `: ${scope.row.approver.username}` }}</td>
									<td v-else style="border: none;">{{ `: -` }}</td>
								</tr>
								<tr style="background-color: transparent;">
									<td style="border: none;width: 130px;">Date Approved</td>
									<td style="border: none;">{{ `: ${formatedDate(scope.row.updated_at)}` }}</td>
								</tr>
								<tr style="background-color: transparent;">
									<td style="border: none;width: 130px;">Payment Slip</td>
									<td v-if="scope.row.media" style="border: none;">
										<a
											:href="scope.row.media.full_url"
											target="_blank"
										>
											{{ `: ${scope.row.media.file_name}` }}
										</a>
										<!-- <el-button
											size="mini"
											@click="dialogEditPaymentSlip=true"
											type="primary"
										>
											Edit
										</el-button> -->
									</td>
									<!-- <td v-else-if="!scope.row.media" style="border: none;">
										{{ `: ` }}
										<el-button
											size="mini"
											@click="dialogAddPaymentSlip=true"
											type="primary"
										>
											Insert
										</el-button>
									</td> -->
								</tr>
								<tr style="background-color: transparent;">
									<td style="border: none;width: 130px;">Total Paid</td>
									<td style="border: none;">
										{{ `: ${formatPrice(scope.row.total_paid)}` }}
									</td>
								</tr>
								<tr style="background-color: transparent;">
									<td style="border: none;width: 130px;">Invoice</td>
									<td v-if="!scope.row.is_requested" class="d-flex" style="border: none;">
										<el-button size="mini" @click="requestInvoiceModal(scope.row.id)" :loading="btnReqInvoice" type="primary">Request</el-button>
									</td>
									<td v-else-if="scope.row.is_requested && scope.row.reference" style="border: none;">
										{{`: ${scope.row.reference}`}}
									</td>
								</tr>
							</table>
							<table v-else-if="scope.row.credit_type==='reduction' || scope.row.credit_type==='Reduction'" border="0" cellspacing="0" cellpadding="0">
								<tr style="background-color: transparent;">
									<td style="border: none;" colspan="2">{{`${scope.row.customer.customer_name} (${scope.row.phone_number})`}}</td>
								</tr>
								<tr style="background-color: transparent;">
									<td style="border: none;width: 130px;">Credit Type</td>
									<td style="border: none;text-transform: capitalize;">{{ `: ${scope.row.credit_type}` }}</td>
								</tr>
								<tr style="background-color: transparent;">
									<td style="border: none;width: 130px;">Credit Requester</td>
									<td v-if="scope.row.requester" style="border: none;">{{ `: ${scope.row.requester.username}` }}</td>
									<td v-else style="border: none;">{{ `: -` }}</td>
								</tr>
								<tr style="background-color: transparent;">
									<td style="border: none;width: 130px;">Date Request</td>
									<td style="border: none;">{{ `: ${formatedDate(scope.row.created_at)}` }}</td>
								</tr>
								<tr style="background-color: transparent;">
									<td style="border: none;width: 130px;">Credit Approver</td>
									<td v-if="scope.row.approver" style="border: none;">{{ `: ${scope.row.approver.username}` }}</td>
									<td v-else style="border: none;">{{ `: -` }}</td>
								</tr>
								<tr style="background-color: transparent;">
									<td style="border: none;width: 130px;">Date Approved</td>
									<td style="border: none;">{{ `: ${formatedDate(scope.row.updated_at)}` }}</td>
								</tr>
							</table>
                        </template>
                    </el-table-column>
                    <el-table-column prop="market_area" label="Market Area" width="150">
                        <template slot-scope="scope">
							<div
								style="height: 13em;"
								v-for="item in scope.row.master_request_topup_markets"
								:key="item.id"
							>
								<p v-if="item.market_area">{{ item.market_area.name }}</p>
								<p v-else>-</p>
							</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="market_type" label="Market Type" width="150">
                        <template slot-scope="scope">
							<div
								style="height: 13em;"
							>
								<table>
									<tr style="background-color: transparent;">
										<td style="border: none;">Authentication</td>
									</tr>
									<tr style="background-color: transparent;">
										<td style="border: none;">Marketing</td>
									</tr>
									<tr style="background-color: transparent;">
										<td style="border: none;">Utility</td>
									</tr>
									<tr style="background-color: transparent;">
										<td style="border: none;">Service</td>
									</tr>
								</table>
							</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="credit_balance" label="Credit Balance" width="130">
                        <template slot-scope="scope">
							<div
								style="height: 13em;"
								v-for="(item, idx) in scope.row.master_request_topup_markets"
								:key="item.id"
							>
								<table>
									<tr style="background-color: transparent;">
										<td style="border: none;">{{ `${formatNumber(item.authentication_before_topup)}` }}</td>
									</tr>
									<tr style="background-color: transparent;">
										<td style="border: none;">{{ `${formatNumber(item.marketing_before_topup)}` }}</td>
									</tr>
									<tr style="background-color: transparent;">
										<td style="border: none;">{{ `${formatNumber(item.utility_before_topup)}` }}</td>
									</tr>
									<tr style="background-color: transparent;">
										<td style="border: none;">{{ `${formatNumber(item.service_before_topup)}` }}</td>
									</tr>
								</table>
							</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="credit_request" label="Credit Request" width="130">
                        <template slot-scope="scope">
							<div
								style="height: 13em;"
								v-for="(item, idx) in scope.row.master_request_topup_markets"
								:key="item.id"
							>
								<table>
									<tr style="background-color: transparent;">
										<td style="border: none;">{{ `${formatNumber(item.authentication)}` }}</td>
									</tr>
									<tr style="background-color: transparent;">
										<td style="border: none;">{{ `${formatNumber(item.marketing)}` }}</td>
									</tr>
									<tr style="background-color: transparent;">
										<td style="border: none;">{{ `${formatNumber(item.utility)}` }}</td>
									</tr>
									<tr style="background-color: transparent;">
										<td style="border: none;">{{ `${formatNumber(item.service)}` }}</td>
									</tr>
								</table>
							</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="mutation" label="Mutation" width="130">
                        <template slot-scope="scope">
							<div
								style="height: 13em;"
								v-for="(item, idx) in scope.row.master_request_topup_markets"
								:key="item.id"
							>
								<table>
									<tr style="background-color: transparent;">
										<td style="border: none;">{{ `${formatNumber(item.authentication_after_topup)}` }}</td>
									</tr>
									<tr style="background-color: transparent;">
										<td style="border: none;">{{ `${formatNumber(item.marketing_after_topup)}` }}</td>
									</tr>
									<tr style="background-color: transparent;">
										<td style="border: none;">{{ `${formatNumber(item.utility_after_topup)}` }}</td>
									</tr>
									<tr style="background-color: transparent;">
										<td style="border: none;">{{ `${formatNumber(item.service_after_topup)}` }}</td>
									</tr>
								</table>
							</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="remark" label="Remark" width="200">
                        <template slot-scope="scope">
							<div style="height: 13em;">
								<p>{{ scope.row.remark }}</p>
							</div>
                        </template>
                    </el-table-column>
                </el-table>
			</el-tab-pane>
		</el-tabs>

        <el-dialog title="Addition Credit Approvement" :visible.sync="dialogAddCreditApprove" v-loading="loadingLoadAdditionCredit" id="html-2-pdfwrapper">
            <el-row class="mt-5">
                <el-card>
                    <el-form label-position="top">
                        <el-form-item label="Payment Slip">
                            <el-upload
								class="upload-demo"
								id="inputMedia"
								:http-request="renderMedia"
								:before-upload="beforeUploadMedia"
								action=""
								drag
								:limit="1"
								list-type="text"
							>
								<i class="el-icon-upload"></i>
								<div class="el-upload__text" @click="renderMedia"
									>Drop file here or <em>click to upload</em>
								</div>
								<div class="el-upload__tip" slot="tip">
									<b>The maximum file upload size is 100 MB</b>
								</div>
							</el-upload>
                        </el-form-item>
                        <el-form-item label="Total paid">
                            <el-input v-model="approvement.total_paid" />
                        </el-form-item>
                        <el-form-item label="Remark">
                            <el-input v-model="approvement.remark" type="textarea" :rows="4" />
                        </el-form-item>
                    </el-form>
                </el-card>
            </el-row>
            <el-row class="mt-40">
                <el-button :loading="btnLoadingApprove" @click="submitApprovement('addition')" size="medium" type="primary">Save</el-button>
                <el-button size="medium" type="danger" @click="dialogAddCreditApprove=false">Cancel</el-button>
            </el-row>
		</el-dialog>
        
        <el-dialog title="Reduction Credit Approvement" :visible.sync="dialogReductionCreditApprove" v-loading="loadingLoadReductionCredit" id="html-2-pdfwrapper">
            <el-row class="mt-5">
                <el-col :span="24" :md="24" :sm="24" :xs="24">
                    <el-form label-position="left">
                        <el-form-item label="Remark">
                            <el-input v-model="reduction.remark" type="textarea" :rows="4" />
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
            <el-row class="mt-40">
                <el-button :loading="btnLoadingApprove" @click="submitApprovement('reduction')" size="medium" type="primary">Save</el-button>
                <el-button size="medium" type="danger" @click="dialogReductionCreditApprove=false">Cancel</el-button>
            </el-row>
		</el-dialog>

		<el-dialog title="Request Invoice" :visible.sync="dialogRequestInvoice" id="html-2-pdfwrapper">
            <el-row class="mt-5">
                <el-col :span="24" :md="24" :sm="24" :xs="24">
                    <el-form label-position="top">
                        <el-form-item label="Date">
                            <el-input type="text" :value="formatedDate(reqInvoiceData.tax_date)" disabled />
                        </el-form-item>
                        <el-form-item label="Invoice Number">
                            <el-input type="text" :value="reqInvoiceData.in_number" disabled />
                        </el-form-item>
                        <el-form-item label="Tax Invoice Number">
                            <el-input type="text" v-model="requestInvoice.invoiceNumber" />
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
            <el-row class="mt-40">
                <el-button :loading="btnLoadingInvoiceNumber" @click="submitInvoiceNumber()" size="medium" type="primary">Save</el-button>
                <el-button size="medium" type="danger" @click="dialogRequestInvoice=false">Cancel</el-button>
            </el-row>
		</el-dialog>

		<el-dialog title="Edit Payment Slip" :visible.sync="dialogEditPaymentSlip" id="html-2-pdfwrapper">
            <el-row class="mt-5">
                <el-card>
                    <el-form label-position="top">
                        <el-form-item label="Upload file">
                            <el-upload
								class="upload-demo"
								id="inputMedia"
								:http-request="renderMedia"
								:before-upload="beforeUploadMedia"
								action=""
								drag
								:limit="1"
								list-type="text"
							>
								<i class="el-icon-upload"></i>
								<div class="el-upload__text" @click="renderMedia"
									>Drop file here or <em>click to upload</em>
								</div>
								<div class="el-upload__tip" slot="tip">
									<b>The maximum file upload size is 100 MB</b>
								</div>
							</el-upload>
                        </el-form-item>
                        <el-form-item label="Total Payment">
                            <el-input type="text" v-model="requestEditPaymentSlip.price"/>
                        </el-form-item>
                    </el-form>
                </el-card>
            </el-row>
            <el-row class="mt-40">
                <el-button size="medium" type="primary">Save</el-button>
                <el-button size="medium" type="danger" @click="dialogEditPaymentSlip=false">Cancel</el-button>
            </el-row>
		</el-dialog>
		
		<el-dialog title="Add Payment Slip" :visible.sync="dialogAddPaymentSlip" id="html-2-pdfwrapper">
            <el-row class="mt-5">
                <el-card>
                    <el-form label-position="top">
                        <el-form-item label="Upload file">
                            <el-upload
								class="upload-demo"
								id="inputMedia"
								:http-request="renderMedia"
								:before-upload="beforeUploadMedia"
								action=""
								drag
								:limit="1"
								list-type="text"
							>
								<i class="el-icon-upload"></i>
								<div class="el-upload__text" @click="renderMedia"
									>Drop file here or <em>click to upload</em>
								</div>
								<div class="el-upload__tip" slot="tip">
									<b>The maximum file upload size is 100 MB</b>
								</div>
							</el-upload>
                        </el-form-item>
                        <el-form-item label="Total Payment">
                            <el-input type="text" v-model="requestAddPaymentSlip.price"/>
                        </el-form-item>
                    </el-form>
                </el-card>
            </el-row>
            <el-row class="mt-40">
                <el-button size="medium" type="primary">Save</el-button>
                <el-button size="medium" type="danger" @click="dialogAddPaymentSlip=false">Cancel</el-button>
            </el-row>
		</el-dialog>
    </el-card>
	<el-card class="mt-20 mb-20 card-base" style="border:none; color:white;">
		DAM Corp.
	</el-card>
	</div>
</template>

<script>
import config from '@/config'
import api from '@/networkClient'
const moment = require('moment')
import Template from './consumen/Template.vue'
import axios from 'axios';

export default {
  components: { Template },
	name: 'Credit',
    data() {
        return {
			activeTab: "approvement",
			loadingDetail: false,
			dialogAddCreditApprove: false,
			loadingLoadAdditionCredit: false,
			dialogReductionCreditApprove: false,
			loadingLoadReductionCredit: false,
			dialogRequestInvoice: false,
			btnLoadingInvoiceNumber: false,
			listApprovementArr: [],
			listClientLedgerArr: [],
			approvement: {
				remark: '',
				files: '',
				id: '',
				total_paid: ''
			},
			reduction: {
				remark: '',
				id: ''
			},
			requestInvoice: {
				invoiceNumber: '',
				id: null
			},
			btnLoadingReject: false,
			btnLoadingApprove: false,
			reqInvoiceData: {},
			btnReqInvoice: false,
			dialogEditPaymentSlip: false,
			dialogAddPaymentSlip: false,
			requestEditPaymentSlip: {
				price: '',
				files: ''
			},
			requestAddPaymentSlip: {
				price: '',
				files: ''
			},
			loadingPage: false
        }
    },
    methods: {
		log(data) {
			console.log(data, " <<data");
		},
		formatPrice(value) {
            if(typeof value == "string") value = parseFloat(value)

            if(value == null || value == "") return "-"
			return value.toLocaleString('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: Number.isInteger(value) ? 0 : 4 })
		},
		formatNumber(value) {
			return value ? value.toLocaleString('id-ID') : '';
		},
		async submitInvoiceNumber() {
			this.btnLoadingInvoiceNumber=true;
			await api({
                url: config.baseApi + `master-collection/request-invoice/${this.requestInvoice.id}`,
                method: 'post',
				data: this.requestInvoice.invoiceNumber
            })
            .then(res => {
				var status =
					res &&
					res.data &&
					res.data.ec
						? res.data.ec
						: null;

				if (status === 200) {
					this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear('invoice'));
					this.listClientGeneralLedger();
				} else {
					this.$swal(this.$t('error'), 'Failed to request invoice', "error").then(this.clear('invoice'))
				}
				this.btnLoadingInvoiceNumber=false;
				this.dialogRequestInvoice=false;
            })
            .catch(err => {
                this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear('invoice'))
                return err
            })
		},
		async requestInvoiceModal(id) {
			this.btnReqInvoice=true;
			await api({
                url: config.baseApi + `master-collection/request-invoice/${id}`,
                method: 'get'
            })
            .then(res => {
				var status =
					res &&
					res.data &&
					res.data.ec
						? res.data.ec
						: null;
				var data =
					res &&
					res.data &&
					res.data.data
						? res.data.data
						: {};
				if (status === 200) {
					this.dialogRequestInvoice=true;
					this.requestInvoice.id=id;
					this.reqInvoiceData = data;
					this.btnReqInvoice=false;
				} else {
					this.$swal(this.$t('error'), 'Failed request invoice!', "error")
				}
            })
            .catch(err => {
                this.$swal(this.$t('error'), this.$t('error_text'), "error")
                return err
            })
		},
		async listApprovement(){
			this.loadingPage=true;
            await api({
                url: config.baseApi + 'master-list-approvement-topup',
                method: 'get'
            })
            .then(res => {
				var status =
					res &&
					res.data &&
					res.data.ec
						? res.data.ec
						: null;
                var data =
                    res &&
                    res.data &&
                    res.data.data &&
                    res.data.data.rows &&
                    res.data.data.rows.rows
                    	? res.data.data.rows.rows
                        : '';

				if (status === 200) {
					this.listApprovementArr = data;
				}
            })
            .catch(err => {
                this.$swal(this.$t('error'), this.$t('error_text'), "error")
                return err
            })
			this.loadingPage=false;
        },
		async listClientGeneralLedger(){
            await api({
                url: config.baseApi + 'master-request-topup',
                method: 'get'
            })
            .then(res => {

				var status =
					res &&
					res.data &&
					res.data.ec
						? res.data.ec
						: null;
                var data =
                    res &&
                    res.data &&
                    res.data.data &&
                    res.data.data.rows
                    	? res.data.data.rows
                        : '';

				if (status === 200) {
					this.listClientLedgerArr = data;
				}
            })
            .catch(err => {
                this.$swal(this.$t('error'), this.$t('error_text'), "error")
                return err
            })
        },
		btnApprovement(statusApprovement, id, data) {
			if(statusApprovement === 'addition') {
				this.dialogAddCreditApprove=true;
				this.approvement.id = id;
				this.approvement.remark = data.remark;
			} else if (statusApprovement === 'reduction') {
				this.dialogReductionCreditApprove=true;
				this.reduction.id = id;
				this.reduction.remark = data.remark;
			}
		},
		async renderMedia(object){
            let size =
                object &&
                object.file &&
                object.file.size
                    ? object.file.size
                    : null;

            if(size >= 104857600){
                this.closeDialog()
                this.$swal(this.$t('error'), "Maximum file upload size is 100 MB", "warning")
                return
            }

            this.approvement.files = object.file;
        },
		beforeUploadMedia(object){
            if(["application/pdf"].indexOf(object.type)==-1){
				this.$swal(this.$t('error'), "Media extension not match (.pdf)", "warning")
				return false
			}
		},
        async uploadMedia(type) {
            let formData = new FormData();
			this.btnLoadingApprove=true

            let apiOptions = {
                timeout: 60000 * 5,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }

			if (type === 'reduction') {
				formData.append('id', this.reduction.id)
				formData.append('files', '')
				formData.append('status', 'approve')
				formData.append('remark', this.reduction.remark)
			} else if (type === 'addition') {
				formData.append('id', this.approvement.id)
				formData.append('files', this.approvement.files)
				formData.append('status', 'approve')
				formData.append('remark', this.approvement.remark)
				formData.append('total_paid', this.approvement.total_paid)
			};

            await axios.post(config.baseApi + 'master-request-topup-approve', formData, apiOptions).then(resp => {
                var statusCode =
                    resp &&
                    resp.data &&
                    resp.data.ec
                        ? resp.data.ec
                        : null;
				let message =
					resp &&
					resp.data &&
					resp.data.message
						? resp.data.message
						: '';
                
                if (statusCode === 200) {
					this.dialogReductionCreditApprove=false;
					this.dialogAddCreditApprove=false;
					this.listApprovement();
					this.listClientGeneralLedger();
                    this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear(type))
                } else {
                    this.$swal(this.$t('error'), message, "error").then(this.clear(type))
                }

				this.dialogReductionCreditApprove = false;
				this.dialogAddCreditApprove = false;
				this.btnLoadingApprove=false
            }).catch(err => {
                console.error(err);
				this.btnLoadingApprove=false
            })
        },
		async submitApprovement(status, data) {
			if (
				status === 'addition' &&
				!this.validation('approveAddition') ||
				status === 'reduction' &&
				!this.validation('approveReduction')
			) {
				this.uploadMedia(status)
			} else if (status === 'reject') {
				let dataTemp = {
					id: data.id,
					status: 'reject'
				};

				await this.$swal({
					title: `Are you sure want to reject ${data.customer.customer_name}?`,
					type: 'warning',
					showCancelButton: true,
					confirmButtonText: 'Reject',
					cancelButtonText: 'Cancel',
					showCloseButton: true,
					showLoaderOnConfirm: true
				}).then(() => {
					api({
						method: 'POST',
						url: config.baseApi + 'master-request-topup-approve',
						data: dataTemp
					}).then(result => {
						const status =
							result &&
							result.data &&
							result.data.ec
								? result.data.ec
								: null;
						const message =
							result &&
							result.data &&
							result.data.message
								? result.data.message
								: '';

						if (status === 200) {
							this.$swal(this.$t('success'), this.$t('success'), "success");
							this.listApprovement();
						} else {
							this.$swal(this.$t('error'), message, "error");
						}
					}).catch(error => {
						console.error("Failed : " + error);
						this.$swal(this.$t('error'), this.$t('error_text'), "error")
					})
				}).catch(err => {
					console.log(err);
				})
			}
		},
		formatedDate(date) {
            return moment(date).format('DD/MM/YYYY, hh:mm')
        },
		validation(type) {
			let allFilled = false
            if (type === 'approveAddition') {
                if (
                    this.approvement.remark === '' ||
                    this.approvement.files === '' ||
                    this.approvement.id === '' ||
                    this.approvement.total_paid === ''
                ) {
                    this.$message.error({
                        showClose: false,
                        message: 'Please fill all inputs!'
                    });
                    allFilled = true
                }
            } else if (type === 'editPaymentSlip') {
				if (
                    this.requestEditPaymentSlip.price === '' ||
                    this.requestEditPaymentSlip.files === ''
                ) {
                    this.$message.error({
                        showClose: false,
                        message: 'Please fill all inputs!'
                    });
                    allFilled = true
                }
			} else if (type === 'approveReduction') {
                if (
                    this.reduction.remark === '' ||
                    this.reduction.id === ''
                ) {
                    this.$message.error({
                        showClose: false,
                        message: 'Please fill all inputs!'
                    });
                    allFilled = true
                }
            }
            return allFilled
		},
		clear(type) {
			if (type === 'reject') {
				this.reject = {
					remark: '',
					id: ''
				}
			} else if (type === 'approve') {
				this.approvement = {
					remark: '',
					files: '',
					id: ''
				}
			} else if (type === 'invoice') {
				this.requestInvoice.invoiceNumber='';
			}
		}
    },
   	async mounted(){
		await this.listApprovement();
		await this.listClientGeneralLedger();
    }
}
</script>
<style scoped>
.swal2-container {
	z-index: 10000 !important;
}

.img-center {
    display: block;
    margin-bottom: 0px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 30px;
    width: 50%;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td, th {
  border: 1px solid #ffffff;
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #dddddd;
}
table th {
  background: #79DFFF;
  color: black;
  font-weight: bold;
  /* font-size: 18px; */
}
/* .css-serial { */
  /* counter-reset: serial-number;  Atur penomoran ke 0 */
/* } */
/* .css-serial td:first-child:before { */
  /* counter-increment: serial-number;  Kenaikan penomoran */
  /* content: counter(serial-number);  Tampilan counter */
/* } */
</style>
<style lang="scss">
@import '../assets/scss/_variables';

.gradient-api {
	background:#249393;
	background: linear-gradient(260deg, #4ac5c5, #249393);
}
.white-text {
	color: white;
}
.page-header {
	margin-bottom: 30px;
}

.row {
	margin-top: 30px;
}

.page-invoice {
	.toolbar {
		max-width: 794px;
		margin: 0 auto;
		text-align: right;
		margin-bottom: 20px;
	}

	.invoice {
		background: white;
		width: 100%;
		max-width: 794px;
		min-height: 1123px;
		margin: 0 auto;
		padding: 2em;
		box-sizing: border-box;
		box-shadow: 0px 8px 8px -8px rgba(0, 0, 0, 0.3);

		hr {
			border: 1px solid rgba(0, 0, 0, 0.05);
		}

		.invoice-top {
			overflow: hidden;
			float: right;
			margin-bottom: 30px;

			.logo {
				float: right;
				height: 60px;
				width: 60px;
				box-sizing: border-box;
				border-radius: 50%;
				overflow: hidden;
				background: rgba(0, 0, 0, 0.07);
				text-align: center;

				img {
					height: 80%;
					margin-top: 10%;
				}
			}
			.info {
				display: block;
				float:left;
				margin-left: 20px;
				margin-top: 5px;

				& > * {
					margin: 0;
				}
			}
			.title {
				float: right;

				& > * {
					margin: 0;
				}

				p {
					text-align: right;
				}
			}
		}

		.invoice-middle {
			overflow: hidden;
			margin-top: 30px;
			margin-bottom: 30px;

			.clientlogo {
				float: left;
				height: 60px;
				width: 60px;
				box-sizing: border-box;
				border-radius: 50%;
				overflow: hidden;
				background: grey;

				img {
					width: 100%;
				}
			}

			.info {
				display: block;
				float:left;
				margin-left: 20px;
				margin-top: 5px;

				& > * {
					margin: 0;
				}
			}

			.project {
				margin-left: 52%;

				& > * {
					margin: 0;
				}
			}
		}

		.invoice-bottom {
			table {
				width: 100%;
				border-collapse: collapse;

				th {
					text-align: right;
					padding: 20px;
					padding-bottom: 5px;
					opacity: .7;

					&:first-child {
						text-align: left;
						padding-left: 0px;
						// width: 100%
					}
					&:last-child {
						padding-right: 0px;
					}
				}

				td {
					text-align: right;
					padding: 20px;
					padding-bottom: 5px;
					border-bottom: 1px solid #EEE;

					&:first-child {
						text-align: left;
						padding-left: 0px;
						// width: 100%;
					}
					&:last-child {
						padding-right: 0px;
					}
				}

				tfoot td {
					border: none;
					padding-top: 5px;
				}
			}
		}

		h1 { font-size: 1.5em; color: #222; }
		h2 { font-size: .9em; }
		h3 { font-size: 1.2em; font-weight: 300; line-height: 2em; }
		p  { font-size: .7em; color: #666; line-height: 1.2em; }
	}

}


@media print{
	.layout-container .container .footer ,
	.layout-container .container .header ,
	.layout-container .container .horizontal-nav ,
	.layout-container .footer ,
	.layout-container .layout-picker ,
	.layout-container .vertical-nav ,
	.layout-container .header {
		display:none;
	}
}
</style>
